import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/workspace/src/components/ui/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card","CardHeader","CardTitle","CardDescription","CardContent"] */ "/workspace/src/components/ui/card.tsx");
